import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import ElementPlus from 'element-plus'
import 'element-plus/dist/index.css'
import fontAwesome from './plugins/fontawesome'
// 引入自定义样式
import './styles/variables.css'
import './styles/base.css'
import './styles/components.css'
// 打印环境变量
console.log('=== 应用启动 ===')
console.log('NODE_ENV:', process.env.NODE_ENV)
console.log('VUE_APP_BASE_API:', process.env.VUE_APP_BASE_API)

const app = createApp(App)

app.use(router)
app.use(ElementPlus)
app.use(fontAwesome)
app.mount('#app')

console.log('=== 应用挂载完成 ===')